// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Sbi5","list":"BalanceDue_list__1Wmor","listRow":"BalanceDue_listRow__1l3VU","total":"BalanceDue_total__SmoGD"};